export default __webpack_public_path__ + "static/media/check-green.03d1c7e6.svg";